import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import LanguageSelect from '../modules/Pricing/LanguageSelect';
import Pricing from '../modules/Pricing';
//import HomepageSettings from '../modules/HomepageSettings';

class PricingPage extends Component {
  render() {
    return (
      <Layout>
        <Container>
          <h1>Ceník</h1>
          <LanguageSelect />
          <Pricing />
        </Container>
      </Layout>
    );
  }
}

export default PricingPage;



// WEBPACK FOOTER //
// ./src/pages/PricingPage.js